import angular from 'angular';
import $ from "jquery";
import header from "./header/header";
import pageHeader from "./page-header/page-header";
import panelToolsTemplate from "./directives/panelTools/panelTools.html";
import panelToolsFullscreenTemplate from "./directives/panelTools/panelToolsFullscreen.html";
import confirmModalComponent from './modals/ConfirmModal/confirmModal.component';
import tableExport from './tableExport/tableExport';
import loadingIndicator from './loadingIndicator/loadingIndicator';
import moment from 'moment';
import heatMap from './directives/heatmap/heatmap';
import tcCalendarWidget from "./directives/calendar/tc-calendar";
import progressRing from "./directives/progress-ring/progress-ring";
import progressBar from "./directives/progress-bar/progress-bar";
import gaugeProgressBar from "./directives/gauge-progress-bar/gauge-progress-bar";
import googleAddressAutocomplete from "./directives/google-address-autocomplete/google-address-autocomplete";
import timesheetGrid from "./directives/timesheet-grid/timesheet-grid";
import tcPhoneNumber from "./directives/phone-number/tc-phone-number";
import tcEmail from "./directives/email/tc-email";
import customerDropdown from "./directives/customer-dropdown/customer-dropdown";
import employeeDropdown from "./directives/employee-dropdown/employee-dropdown";
import contractDropdown from "./directives/contract-dropdown/contract-dropdown";
import laborCategoryDropdown from "./directives/labor-category-dropdown/labor-category-dropdown";
import s3FileBrowser from "./directives/s3-file-browser/s3-file-browser";
import wysiwygEditor from "./directives/wysiwyg-editor/wysiwyg-editor";
import springDataTable from "./springDataTable/springDataTable";
import settingsSidebar from "./settings-sidebar/settings-sidebar";
import documentViewer from './document-viewer/document-viewer'
import Utilities from './utilities';
import Services from './services/services';
import Dropzone from 'dropzone'
import 'ngdropzone'
import 'jquery/dist/jquery';
import 'bootstrap/dist/js/bootstrap';
import 'icheck';
import 'bootstrap-tour';
import 'angular-bootstrap-tour';
import 'metismenu';
import 'angular-avatar';
import 'jquery-sparkline/jquery.sparkline';
import 'jquery-slimscroll/jquery.slimscroll';
import 'flot/jquery.flot';
import 'flot/jquery.flot.pie';
import 'flot/jquery.flot.time';
import 'flot/jquery.flot.categories';
import 'flot.curvedlines/curvedLines';
import 'flot-spline/js/jquery.flot.spline';
import '../js/angular-flot';
import 'angular-chart.js/dist/angular-chart.min';
import 'angular-sweetalert/SweetAlert';
import 'vsGoogleAutocomplete/dist/vs-google-autocomplete';
import 'angular-toastr';
import 'angular-phone-input';
import 'angular-xeditable';
import 'angular-bootstrap-toggle';
import 'footable/dist/footable.all';
import 'angular-footable/dist/angular-footable';
import 'angular-save-html-to-pdf/dist/saveHtmlToPdf';
import 'footable/dist/footable.all';
import 'ng-idle';
import 'angularjs-gauge/dist/angularjs-gauge';

import 'angular-cookies';


import 'datatable-sorting-datetime-moment';
import 'datatables-columnfilter/dist/dataTables.lightColumnFilter';
import 'datatables/media/js/jquery.dataTables';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import 'datatables.net-buttons/js/buttons.colVis';


import 'datatables.net-bs4/js/dataTables.bootstrap4';
import 'datatables.net-buttons/js/dataTables.buttons';
import 'datatables.net-buttons-bs4/js/buttons.bootstrap4'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import 'angular-datatables';



// Make utilities available globally if needed
window.Utilities = Utilities;

// Export for module use
export { Utilities };


let commonModule = angular.module('app.common', [header.name, pageHeader.name,
    tableExport.name, loadingIndicator.name,
    heatMap.name, springDataTable.name, settingsSidebar.name,
    documentViewer.name,tcCalendarWidget.name, progressRing.name, progressBar.name, gaugeProgressBar.name, googleAddressAutocomplete.name, timesheetGrid.name, tcPhoneNumber.name, tcEmail.name, customerDropdown.name, employeeDropdown.name, contractDropdown.name, laborCategoryDropdown.name, s3FileBrowser.name, wysiwygEditor.name, Services.name,
  'datatables',
  'datatables.bootstrap',
  'datatables.buttons',
  'datatables.light-columnfilter',
  'bm.bsTour',
  'ngAvatar',
  'angular-flot',
  'oitozero.ngSweetAlert',
  'vsGoogleAutocomplete',
  'toastr',
  'angular-phone-input',
  'xeditable',
  'ui.toggle',
  'ui.footable',
  'htmlToPdfSave',
  'ngCookies',
  'ngIdle',
  'thatisuday.dropzone',
  'angularjs-gauge',
]);


commonModule.component('confirmModal', confirmModalComponent);



commonModule.directive('repeatDone', function() {
    return function(scope, element, attrs) {
      if (scope.$last) {
        $(".table").dataTable({ });
      }
    }
});

commonModule.directive('fooRepeatDone', function() {
  return function($scope, element) {
    if ($scope.$last) { // all are rendered
      $('.table').trigger('footable_redraw');
    }
  }
});



commonModule.directive('pageTitle', function($rootScope, $timeout) {
    return {
        link: function(scope, element) {
            var listener = function(event, toState, toParams, fromState, fromParams) {
                // Default title
                var title = 'HOMER | AngularJS Responsive WebApp';
                // Create your own title pattern
                if (toState.data && toState.data.pageTitle) title = 'HOMER | ' + toState.data.pageTitle;
                $timeout(function() {
                    element.text(title);
                });
            };
            $rootScope.$on('$stateChangeStart', listener);
        }
    }
});

commonModule.directive('icheck', function($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {

                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                    if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                        $scope.$apply(function() {
                            return ngModel.$setViewValue(event.target.checked);
                        });
                    }
                    if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                        return $scope.$apply(function() {
                            return ngModel.$setViewValue(value);
                        });
                    }
                });
            });
        }
    };
});

commonModule.directive('sideNavigation', function ($timeout) {
    return {
        restrict: 'A',
        link: function(scope, element) {
            // Call the metsiMenu plugin and plug it to sidebar navigation
            element.metisMenu();

            // Colapse menu in mobile mode after click on element
            var menuElement = $('#side-menu a:not([href$="\\#"])');
            menuElement.click(function(){

                if ($(window).width() < 769) {
                    $("body").toggleClass("show-sidebar");
                }
            });

            // Check if sidebar scroll is enabled
            if($('body').hasClass('sidebar-scroll')) {
                var navigation = element.parent();
                navigation.slimScroll({
                    height: '100%',
                    opacity: 0.3,
                    size : 0,
                    wheelStep : 5,
                    allowPageScroll : true,
                });
            }


        }
    };
});

commonModule.directive('minimalizaMenu', function ($rootScope) {
    return {
        restrict: 'EA',
        template: '<div class="header-link hide-menu" ng-click="minimalize()"><i class="fa-thin fa-bars"></i></div>',
        controller: function ($scope, $element) {

            // if ($(window).width() < 769) {
            //     $("body").toggleClass("show-sidebar");
            // } else {
            //     $("body").toggleClass("hide-sidebar");
            // }


            $scope.minimized = false;

            $scope.minimalize = function () {

                if($scope.minimized) {
                    $("body").toggleClass("show-sidebar");
                } else {
                    $("body").toggleClass("hide-sidebar");
                }

                $scope.minimized = !$scope.minimized;

                // if ($(window).width() < 769) {
                //     $("body").toggleClass("show-sidebar");
                // } else {
                //     $("body").toggleClass("hide-sidebar");
                // }
            }
        }
    };
});

commonModule.directive('sparkline', function () {
    return {
        restrict: 'A',
        scope: {
            sparkData: '=',
            sparkOptions: '=',
        },
        link: function (scope, element, attrs) {
            scope.$watch(scope.sparkData, function () {
                render();
            });
            scope.$watch(scope.sparkOptions, function(){
                render();
            });
            var render = function () {
                $(element).sparkline(scope.sparkData, scope.sparkOptions);
            };
        }
    }
});

commonModule.directive('panelTools', function ($timeout) {
    return {
        restrict: 'A',
        scope: true,
        template: panelToolsTemplate,
        controller: function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {

                var hpanel = $element.closest('div.hpanel');
                var icon = $element.find('i:first');
                var body = hpanel.find('div.panel-body');
                var footer = hpanel.find('div.panel-footer');
                body.slideToggle(300);
                footer.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                hpanel.toggleClass('').toggleClass('panel-collapse');
                $timeout(function () {
                    hpanel.resize();
                    hpanel.find('[id^=map-]').resize();
                }, 50);
            },

                // Function for close ibox
                $scope.closebox = function () {
                    var hpanel = $element.closest('div.hpanel');
                    hpanel.remove();
                }

        }
    };
});

commonModule.directive('panelToolsFullscreen', function ($timeout) {
    return {
        restrict: 'A',
        scope: true,
        template: panelToolsFullscreenTemplate,
        controller: function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var hpanel = $element.closest('div.hpanel');
                var icon = $element.find('i:first');
                var body = hpanel.find('div.panel-body');
                var footer = hpanel.find('div.panel-footer');
                body.slideToggle(300);
                footer.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                hpanel.toggleClass('').toggleClass('panel-collapse');
                $timeout(function () {
                    hpanel.resize();
                    hpanel.find('[id^=map-]').resize();
                }, 50);
            };

            // Function for close ibox
            $scope.closebox = function () {
                var hpanel = $element.closest('div.hpanel');
                hpanel.remove();
                if($('body').hasClass('fullscreen-panel-mode')) { $('body').removeClass('fullscreen-panel-mode');}
            };

            // Function for fullscreen
            $scope.fullscreen = function () {
                var hpanel = $element.closest('div.hpanel');
                var icon = $element.find('i:first');
                $('body').toggleClass('fullscreen-panel-mode');
                icon.toggleClass('fa-expand').toggleClass('fa-compress');
                hpanel.toggleClass('fullscreen');
                setTimeout(function() {
                    $(window).trigger('resize');
                }, 100);
            }

        }
    };
});

commonModule.directive('smallHeader', function () {
    return {
        restrict: 'A',
        scope:true,
        controller: function ($scope, $element) {
            $scope.small = function() {
                var icon = $element.find('i:first');
                var breadcrumb  = $element.find('#hbreadcrumb');
                $element.toggleClass('small-header');
                breadcrumb.toggleClass('m-t-lg');
                icon.toggleClass('fa-arrow-up').toggleClass('fa-arrow-down');
            }
        }
    }
});

commonModule.directive('animatePanel', function ($timeout,$state) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {

            //Set defaul values for start animation and delay
            var startAnimation = 0;
            var delay = 0.06;   // secunds
            var start = Math.abs(delay) + startAnimation;

            // Store current state where directive was start
            var currentState = $state.current.name;

            // Set default values for attrs
            if(!attrs.effect) { attrs.effect = 'zoomIn'};
            if(attrs.delay) { delay = attrs.delay / 10 } else { delay = 0.06 };
            if(!attrs.child) { attrs.child = '.row > div'} else {attrs.child = "." + attrs.child};

            // Get all visible element and set opactiy to 0
            var panel = element.find(attrs.child);
            panel.addClass('opacity-0');

            // Count render time
            var renderTime = panel.length * delay * 1000 + 700;

            // Wrap to $timeout to execute after ng-repeat
            $timeout(function(){

                // Get all elements and add effect class
                panel = element.find(attrs.child);
                panel.addClass('stagger').addClass('animated-panel').addClass(attrs.effect);

                var panelsCount = panel.length + 10;
                var animateTime = (panelsCount * delay * 10000) / 10;

                // Add delay for each child elements
                panel.each(function (i, elm) {
                    start += delay;
                    var rounded = Math.round(start * 10) / 10;
                    $(elm).css('animation-delay', rounded + 's');
                    // Remove opacity 0 after finish
                    $(elm).removeClass('opacity-0');
                });

                // Clear animation after finish
                $timeout(function(){
                    $('.stagger').css('animation', '');
                    $('.stagger').removeClass(attrs.effect).removeClass('animated-panel').removeClass('stagger');
                    panel.resize();
                }, animateTime)

            });



        }
    }
});

commonModule.directive('landingScrollspy', function (){
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.scrollspy({
                target: '.navbar-fixed-top',
                offset: 80
            });
        }
    }
});

commonModule.directive('clockPicker', function () {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.clockpicker();
        }
    };
});

commonModule.directive('datePicker', () => {
  const DATE_FORMAT = 'YYYY-MM-DD';

  return {
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attributes, ctrl) => {
      element.datetimepicker({
        format: DATE_FORMAT,
      });

      ctrl.$formatters.push((value) => {
        const date = moment(value);
        if (date.isValid()) {
          return date.format(DATE_FORMAT);
        }
        return '';
      });

      element.on('dp.change', ({date}) => {
        scope.$apply(() => {
          ctrl.$setViewValue(date.format(DATE_FORMAT));
        });
      });
    }
  }
})


export default commonModule;



// WEBPACK FOOTER //
// ./client/common/common.js